import * as yup from 'yup';
import type { PhoneBillFileEntry } from '@t/checkout.types';
import { isPhoneNumberValid } from '@utils/phoneNumberValidation/phoneNumberValidation';

export const phoneNumberSchema = yup.object({
  choice: yup.string().required(),
  portInNumber: yup.string().when('choice', {
    is: 'PORTIN',
    then: (s) =>
      s.required('Phone number is required').test('phone', 'Please enter a valid phone number', isPhoneNumberValid),
  }),
  portInProvider: yup.string().when('choice', {
    is: 'PORTIN',
    then: (s) => s.required('Service provider is required'),
  }),
  portInProviderOther: yup.string().when(['choice', 'portInProvider'], {
    is: (choice: string, provider: string) => choice === 'PORTIN' && provider === 'Other',
    then: (s) => s.required("Provider's name is required"),
  }),
  accountNumber: yup.string().when('choice', {
    is: 'PORTIN',
    then: (s) => s.required('Account number is required'),
  }),
  nameOnBill: yup.string().when('choice', {
    is: 'PORTIN',
    then: (s) => s.required('Name on bill is required'),
  }),
  phoneBillFiles: yup.array().when('choice', {
    is: 'PORTIN',
    then: (s) =>
      s.test('hasBill', 'Please upload a copy of your phone bill', function (value) {
        const existing = (this.parent as { existingPhoneBillFiles?: PhoneBillFileEntry[] }).existingPhoneBillFiles;
        return (value?.length ?? 0) + (existing?.length ?? 0) >= 1;
      }),
  }),
  existingPhoneBillFiles: yup.array(),
  directoryListing: yup.string(),
});
